import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { FetchTeamLeaders, FetchTeamLeadersFailure, FetchTeamLeadersSuccess } from '../actions';

@Injectable()
export class TeamLeadersResolver  {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const teamId = route.params['teamId'];
        this._store.dispatch(new FetchTeamLeaders(teamId));

        return this._actionHelper.race(FetchTeamLeadersSuccess, FetchTeamLeadersFailure);
    }
}
